import { Component } from '@angular/core';

@Component({
  selector: 'app-gmdashboard-landing',
  templateUrl: './gmdashboard-landing.component.html',
  styleUrls: ['./gmdashboard-landing.component.scss']
})
export class GmdashboardLandingComponent {
}
